import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "children", "cursor", "size", "width", "minWidth", "maxWidth", "focused"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { mergeStyles } from '../../utils';
import { useInputSize, InputSizeContext } from '../../hooks';
import { InputAdornment } from '../../../inputAdornment';
import { Spinner } from '../../../loader';
import inputGroupStyles from '../../../internal/styles/inputWrapperGroup.module.css';
import inputAdornmentStyles from '../../../internal/styles/inputWrapperAdornment.module.css';
import { getStyles } from './styles/getStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InputWrapper = /*#__PURE__*/React.forwardRef(function InputWrapper(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    children = props.children,
    cursor = props.cursor,
    sizeProp = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    focused = props.focused,
    rest = _objectWithoutProperties(props, _excluded);
  var size = useInputSize(sizeProp);
  var styles = mergeStyles(getStyles(size), inputGroupStyles, inputAdornmentStyles);
  var leftAdornmentContent = leftAdornment;
  var rightAdornmentContent = loading ? /*#__PURE__*/_jsx(InputAdornment, {
    children: /*#__PURE__*/_jsx(Spinner, {
      color: "gray_icons_100",
      size: 16
    })
  }) : rightAdornment;
  return /*#__PURE__*/_jsx(InputSizeContext.Provider, {
    value: size,
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      className: cx(styles['input-wrapper'], focused && styles['focused'], invalid && styles['invalid'], disabled && styles['disabled'], inline && styles['inline'], props.className),
      style: {
        cursor: cursor,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth
      },
      tabIndex: disabled ? -1 : props.tabIndex,
      children: [leftAdornmentContent && /*#__PURE__*/_jsx("span", {
        className: styles['left-adornment'],
        children: leftAdornmentContent
      }), /*#__PURE__*/_jsx("div", {
        className: styles['children-wrapper'],
        children: children
      }), rightAdornmentContent && /*#__PURE__*/_jsx("span", {
        className: styles['right-adornment'],
        children: rightAdornmentContent
      })]
    }))
  });
});